import React from 'react'
import { useSelector } from 'react-redux'

import classNames from 'classnames'

import LoadingIndicator from '@lyrahealth-inc/ui-core/lib/atoms/loadingIndicator/LoadingIndicator'
import BootstrapContainer from '@lyrahealth-inc/ui-core/lib/molecules/layouts/bootstrapContainer/BootstrapContainer'

import styles from './bcDashboard.module.scss'
import ActivitiesDashlet from './dashlets/ActivitiesDashlet'
import CapacityDashlet from './dashlets/CapacityDashlet'
import MessagesDashlet from './dashlets/MessagesDashlet'
import SelfHarmDashlet from './dashlets/SelfHarmDashlet'
import TreatmentSummaryLetterDashlet from './dashlets/TreatmentSummaryLetterDashlet'
import UnclosedSessionsDashlet from './dashlets/UnclosedSessionsDashlet'
import UnfinishedNotesDashlet from './dashlets/UnfinishedNotesDashlet'
import UpcomingSessionsDashlet from './dashlets/UpcomingSessionsDashlet'
import { getAuthUserId } from '../../data/auth/authSelectors'
import { useAllClientsData } from '../clients/data/hooks/useAllClientsData'
import { useConversationsData } from '../messages/data/hooks/useConversationsData'

export const BCDashboard: React.FC = () => {
  const userId = useSelector(getAuthUserId)
  const { isLoading: isLoadingConversations } = useConversationsData()

  const [_, { isSuccess: activeClientsFetched }, { isSuccess: inactiveClientsFetched }] = useAllClientsData()
  return (
    <BootstrapContainer col='col-md-12' style={{ marginBottom: '50px', width: '85%' }}>
      <div
        className={classNames(styles['inactive-loading-container'], {
          [styles.hidden]: activeClientsFetched && inactiveClientsFetched && !isLoadingConversations,
        })}
      >
        {/* @ts-expect-error TS(2322): Type '{ size: number; style: { marginRight: string... Remove this comment to see the full error message */}
        <LoadingIndicator size={25} style={{ marginRight: '10px' }} />
        Loading latest data
      </div>
      <div className='row'>
        <div className={classNames('col-md-4', styles.dashlet)}>
          <MessagesDashlet />
          <ActivitiesDashlet providerId={userId} />
        </div>
        <div className={classNames('col-md-4', styles.dashlet)}>
          <UnfinishedNotesDashlet providerId={userId} />
          <UnclosedSessionsDashlet providerId={userId} />
          <TreatmentSummaryLetterDashlet providerId={userId} />
        </div>
        <div className={classNames('col-md-4', styles.dashlet)}>
          <CapacityDashlet />
          <UpcomingSessionsDashlet providerId={userId} />
          {/* Risk alerts are limited to the provider's primary/assigned clients. */}
          <SelfHarmDashlet providerId={userId} />
        </div>
      </div>
    </BootstrapContainer>
  )
}
export default BCDashboard
